export default __webpack_public_path__ + "static/media/logo01.f6fd386a.svg";